<i18n lang="yaml" locale="en">
  items top: top
  items center: centered vertically
  items bottom: bottom
  background color: Choose background color
  text color: Choose text color
  padding: Padding
  alignment: Align content
  vertically scrollable: Vertically scrollable
  link: Link
  with icon: Add icon
  font: Font
  add font long: Add a font by dropping it here.
  add font short: Add as font.
</i18n>

<i18n lang="yaml" locale="de">
  items top: oben
  items center: vertikal zentriert
  items bottom: unten
  background color: Hintergrundfarbe wählen
  text color: Textfarbe wählen
  padding: Innenabstand
  alignment: Inhalt ausrichten
  vertically scrollable: Vertikal scrollbar
  link: Link
  with icon: Icon hinzufügen
  font: Schriftart
  add font long: Fügen Sie eine Schriftart hinzu, indem Sie sie hier ablegen.
  add font short: Als Schriftart hinzufügen.
</i18n>

<template>
  <div
    :class="boxClasses"
    :style="positionStyle"
    @click.capture="handleLink"
  >
    <template
      v-if="children.length > 0"
    >
      <component
        v-for="child in children"
        :key="child.getters.path"
        :path="child.getters.path"
        :is="child.getters.type"
        v-bind="child.getters.props"
        :class="contentClasses"
        :style="contentStyle"
      />
    </template>
    <div
      v-else
      :class="contentClasses"
      :style="contentStyle"
    />
    <box-editor
      v-if="$editMode && gridActive"
      ref="editor"
    />
  </div>
</template>

<script>
import Base from './Base'
import BoxEditor from '@/components/editor/BoxEditor'
import translatable from '@/store/mixins/translatable'
import fontHandler from '@/mixins/fontHandler'
import colors from '@/defaultColors'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'box',
  extends: Base,
  customStore: translatable,
  components: {
    boxEditor: BoxEditor
  },
  mixins: [fontHandler([
    'font'
  ])],
  props: {
    // eslint-disable-next-line
    _headlineBackgroundColor: {
      input: 'heading',
      label: 'background color'
    },
    backgroundColor: {
      type: String,
      input: 'color',
      default: colors.colorMain
    },
    // eslint-disable-next-line
    _headlineTextColor: {
      input: 'heading',
      label: 'text color'
    },
    textColor: {
      type: String,
      input: 'color',
      default: '#fff'
    },
    // eslint-disable-next-line
    _headlineAlignment: {
      input: 'heading',
      label: 'alignment'
    },
    itemAlignment: {
      type: String,
      input: 'radio',
      choices: {
        'items-top': 'items top',
        'items-center': 'items center',
        'items-bottom': 'items bottom'
      },
      default: 'items-top',
      validator (value) {
        return ['items-top', 'items-center', 'items-bottom'].includes(value)
      }
    },
    padding: {
      label: 'padding',
      input: 'checkbox',
      type: Boolean,
      default: false
    },
    scrollY: {
      label: 'vertically scrollable',
      input: 'checkbox',
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line
    _headlineLink: {
      input: 'heading',
      label: 'link'
    },
    link: {
      type: String,
      input: 'link',
      default: ''
    },
    withIcon: {
      label: 'with icon',
      input: 'checkbox',
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    _headlineFont: {
      input: 'heading',
      label: 'font'
    },
    font: {
      input: 'drop',
      type: String,
      contentType: 'font',
      placeholder: 'add font long',
      tooltip: 'add font short',
      default: ''
    }
  },
  methods: {
    handleLink (event) {
      if (this.link && !this.$editMode) {
        const action = this.$root.$store.state.actions[this.link]
        if (action) {
          action()
        } else {
          this.$router.push(this.link)
        }
        event.stopPropagation()
      }
    }
  },
  computed: {
    boxClasses () {
      return {
        box: true,
        button: this.link && !this.$editMode,
        'with-icon': this.link && this.withIcon,
        'edit-mode': this.$editMode
      }
    },
    contentClasses () {
      return {
        content: true,
        [this.itemAlignment]: true,
        padding: this.padding,
        [this.$project.format]: true,
        'scroll-y-light': this.scrollY
      }
    },
    contentStyle () {
      return {
        'background-color': this.backgroundColor,
        color: this.textColor,
        ...this.fontStyles.font
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './box';

.box {
  &.button:active {
    transform: scale(0.98);
  }

  &.with-icon {
    /deep/ > .content::before {
      content: url('~@/assets/icons/tw-icon-button-white.svg');
      width: 24px;
      height: 24px;
      position: absolute;
      top: 14px;
      right: 14px;
      z-index: z(boxIcon);
    }
  }

  &.edit-mode {
    box-shadow: 0 0 1px #ff0080;
  }
}
</style>
